import React from "react";
import '../../src/style.css';
const Historycard = ({ title, image }) => {
  return (
    <div className="custom-card mb-2" style={{padding:'6px'}}>
        <div className="row align-items-center">
    <div className="col-12">
    <div className="text-center card-body">
      <p className="card-title" style={{fontSize:'15px'}}>{title}</p>
    </div>
  </div>
  </div>

  <div className="row align-items-center">
  <div className="col-12 text-center">
    <img src={image} className="card-img-top" alt={title} style={{width:"40%"}} />
  </div>

</div>
    </div>
  );
};

export default Historycard;
